module.exports = __webpack_public_path__ + "img/images.4eea80ea.svg";